import { SVGProps } from 'react';

export default function SnowflakeIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      fill='none'
      viewBox='0 0 24 24'
      strokeWidth={1.5}
      stroke='currentColor'
      aria-hidden='true'
      {...props}
    >
      <path
        strokeLinecap='round'
        strokeLinejoin='round'
        d='M12 3v18M3 12h18M5.636 5.636l12.728 12.728M18.364 5.636 5.636 18.364M12 5.25l-1.5-1.5M12 5.25l1.5-1.5M12 18.75l-1.5 1.5M12 18.75l1.5 1.5M5.25 12l-1.5-1.5M5.25 12l-1.5 1.5M18.75 12l1.5-1.5M18.75 12l1.5 1.5M7.05 7.05l-1.06-2.05M7.05 7.05l-2.05-1.06M16.95 16.95l1.06 2.05M16.95 16.95l2.05 1.06M16.95 7.05l1.06-2.05M16.95 7.05l2.05-1.06M7.05 16.95l-1.06 2.05M7.05 16.95l-2.05 1.06'
      />
    </svg>
  );
}
